import React from "react";
import { Button, ButtonGroup, Label } from "reactstrap";

const StatusToggle = ({
  name,
  value,
  onChange,
  label,
  trueLabel = "Active",
  falseLabel = "Inactive",
}) => {
  const handleToggle = (status) => {
    onChange({
      target: {
        name,
        value: status,
      },
    });
  };

  return (
    <>
      <ButtonGroup className="status-toggle">
        <Button
          type="button"
          className={`toggle-btn left ${
            value == true ? "btn-gradient-primary" : ""
          }`}
          onClick={() => handleToggle(true)}
        >
          <i className="ni ni-check-bold mr-1" />
          {trueLabel}
        </Button>

        <Button
          type="button"
          className={`toggle-btn right ${!value ? "btn-gradient-primary" : ""}`}
          onClick={() => handleToggle(false)}
        >
          <i className="ni ni-fat-remove mr-1" />
          {falseLabel}
        </Button>
      </ButtonGroup>
    </>
  );
};

export default StatusToggle;
